import { useRef } from 'react'
import styled from 'styled-components'
import { Flex } from '../../ui/Layout'
import Button from '../../ui/Button'
import { H2, Text } from '../../ui/Typography'
import { useFormConfig } from '../../context/FormConfigContext'
import { Container } from '../Intro'

const HiddenFileInput = styled.input`
  display: none;
`

const Tips = ({ onNext, onBack }) => {
  const { formConfig } = useFormConfig()

  return (
    <Container>
      <Text fontSize="24px" fontWeight="600" mb="24px">
        Tips for Your Video
      </Text>

      <Text whiteSpace="pre-wrap" mb="24px">
        {formConfig?.tips || 'Here are some tips for recording your video testimonial...'}
      </Text>

      <Flex flexDirection="column" mt="24px">
        <Button backgroundColor={formConfig.buttonColor} large variant="black" label="Continue" onClick={onNext} mb="16px" />
      </Flex>
    </Container>
  )
}

export default Tips
